import ReactDOMServer from 'react-dom/server';
import React from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import Box from '@material-ui/core/Box';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';

// components
import L from 'leaflet';
import {
  Marker, Popup, Tooltip,
} from 'react-leaflet';
import WaterQualityStatusColor from '../../waterQuality/map/WaterQualityStatusColor';
import StyledMarker from '../../../components/marker/Marker';

// leaflet
import 'leaflet/dist/leaflet.css';
import '../../../components/map/Style.css';

import { styles } from '../style';

const useStyles = makeStyles(styles);
const styleMarker = {
  type: 'waterquality',
  level3: {
    icon: 'QualityIcon',
    label: 'shapeSquare',
    color: '#ff0000',
  },
  level4: {
    icon: 'QualityIcon',
    label: 'shapeSquare',
    color: '#B02318',
  },
};

export default function WaterQualityMap(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const { datas } = props;

  function conditionColor(code) {
    if (code === '#66C803' || code === '#FFD966') {
      return '#000000';
    }
    return '#FFFFFF';
  }

  function waterQualityStatusBadge(data, value, key) {
    const status = WaterQualityStatusColor(data, key);
    const statusText = `
      <div
        style=background:${status.color.statusColor};text-align:center;width:60px;color:${conditionColor(status.color.statusColor)};
      >
      ${value}
      </div>`;
    return typeof value === 'undefined' || value == null ? '-' : statusText;
  }

  const eachData = (data, i) => {
    if (data.tele_station_lat && data.tele_station_long) {
      // marker position
      const position = [parseFloat(data.tele_station_lat),
        parseFloat(data.tele_station_long)];

      const WqSalinity = waterQualityStatusBadge(
        data.waterquality_salinity,
        data.waterquality_salinity,
        'salinity',
      );
      const WqDo = waterQualityStatusBadge(
        data.waterquality_do,
        data.waterquality_do,
        'do',
      );
      // const WqPh = waterQualityStatusBadge(
      // data.waterquality_ph,
      // data.waterquality_ph,
      // 'ph',
      // );
      // const WqTurbid = waterQualityStatusBadge(
      // data.waterquality_turbid,
      // data.waterquality_turbid,
      // 'turbid',
      // );
      // const WqTds = waterQualityStatusBadge(
      // data.waterquality_tds,
      // data.waterquality_tds,
      // 'tds',
      // );

      // marker icons
      const styleClass = (data.level === 3) ? styleMarker.level3 : styleMarker.level4;
      const icon = L.divIcon({
        className: 'styleClass',
        html: ReactDOMServer.renderToString(<StyledMarker
          category={styleMarker.type}
          type={styleClass}
        />),
      });

      return (
        <Marker
          id={data.id}
          key={i}
          position={position}
          icon={icon}
        >
          <Popup autoPan={false}>
            <TableContainer>
              <Table size="small">
                <TableHead />
                <TableBody>
                  <TableRow>
                    <TableCell className={classes.hiddenLine} padding="none" align="center" colSpan={3}>
                      <Box fontWeight="500" fontFamily="Kanit" fontSize="14px">
                        {data.name}
                      </Box>
                      <Box fontFamily="Kanit" fontSize="12px">
                        {data.tumbon_name !== '' ? `ต. ${data.tumbon_name} ` : null}
                        {`อ. ${data.amphoe_name} `}
                        {`จ. ${data.province_name}`}
                      </Box>
                    </TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell padding="none" align="center"
                    colSpan={3} style={{ paddingTop: 15 }} />
                  </TableRow> */}
                  {/* <TableRow>
                    <TableCell className={classes.hiddenLine} style={{ paddingTop: 6 }}>
                      <Box fontWeight={600} fontSize={12}>
                        กรด-ด่าง
                      </Box>
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="center">
                      <Box
                        className={`${classes.status}`}
                        style={{ whiteSpace: 'nowrap' }}
                        dangerouslySetInnerHTML={{ __html: WqPh }}
                      />
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="center" />
                  </TableRow> */}
                  <TableRow>
                    <TableCell className={classes.hiddenLine}>
                      <Box fontWeight={600} fontSize={12}>
                        {t('ความเค็ม')}
                      </Box>
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="center">
                      <Box
                        className={`${classes.status}`}
                        dangerouslySetInnerHTML={{ __html: WqSalinity }}
                      />
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="left">(g/L)</TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell className={classes.hiddenLine}>
                      <Box fontWeight={600} fontSize={12}>
                        ความขุ่น
                      </Box>
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="center">
                      <Box
                        className={`${classes.status}`}
                        dangerouslySetInnerHTML={{ __html: WqTurbid }}
                      />
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="left">(ntu)</TableCell>
                  </TableRow> */}
                  {/* <TableRow>
                    <TableCell className={classes.hiddenLine}>
                      <Box fontWeight={600} fontSize={12}>
                        สารละลาย
                      </Box>
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="center">
                      <Box
                        className={`${classes.status}`}
                        dangerouslySetInnerHTML={{ __html: WqTds }}
                      />
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="left">(mg/L)</TableCell>
                  </TableRow> */}
                  <TableRow>
                    <TableCell className={classes.hiddenLine}>
                      <Box fontWeight={600} fontSize={12}>
                        {t('ออกซิเจน')}
                      </Box>
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="center">
                      <Box
                        className={`${classes.status}`}
                        dangerouslySetInnerHTML={{ __html: WqDo }}
                      />
                    </TableCell>
                    <TableCell className={classes.hiddenLine} align="left">(mg/L)</TableCell>
                  </TableRow>
                  {/* <TableRow>
                    <TableCell padding="none" align="center" colSpan={3}
                    style={{ paddingTop: 10 }} />
                  </TableRow> */}
                  <TableRow>
                    <TableCell
                      className={classes.hiddenLine}
                      style={{ paddingTop: 10 }}
                      colSpan={3}
                    >
                      <Box fontSize="10px">{`${t('ข้อมูล')} : ${data.agency_name}`}</Box>
                      <Box fontSize="10px">
                        {`${t('ล่าสุด')} : `}
                        {data.datetime}
                        {' '}
                        {t('น.')}
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Popup>
          <Hidden smDown>
            <Tooltip>
              <span>
                <strong>
                  {data.name}
                </strong>
                <br />
                {`${t('ต.')} ${data.tumbon_name}`}
                <br />
                {`${t('อ.')} ${data.amphoe_name}`}
                <br />
                {`${t('จ.')} ${data.province_name}`}
              </span>
            </Tooltip>
          </Hidden>
        </Marker>
      );
    }
    return false;
  };

  return (
    <>
      {datas.map(eachData)}
    </>
  );
}

WaterQualityMap.propTypes = {
  datas: PropTypes.instanceOf(Array).isRequired,
};
